// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RenderIndex[data-v-557e7fe5]{width:100vw}.directionPointer[data-v-557e7fe5]{width:100px;height:110px;position:absolute;right:-10px;top:40px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
